import { ExchangeVariantPriceInfoFragment, ResultsLegFragment } from '@websky/graphql';
import { SelectedFare } from '../../../../DesktopFlight/types';

export function getFilteredByPricesFlights(
	flightsOnLeg: ResultsLegFragment[],
	selectedFlights: SelectedFare[],
	prices: ExchangeVariantPriceInfoFragment[]
): ResultsLegFragment[] {
	if (!flightsOnLeg.length) {
		return [];
	}

	const lastSelectedFlight = selectedFlights[selectedFlights.length - 1];

	const pricesMap = new Map(prices.map(price => [price.flightId, price]));

	return flightsOnLeg
		.filter(flight =>
			flight.pricesForFareGroups.some(fareGroup => {
				if (!fareGroup.prices) {
					return false;
				}

				if (lastSelectedFlight) {
					const priceIdsSet = new Set(lastSelectedFlight.prices.map(price => price.flight.id));

					return fareGroup.prices.some(price => priceIdsSet.has(price.flight.id));
				}

				return true;
			})
		)
		.map(flight => ({
			...flight,
			pricesForFareGroups: flight.pricesForFareGroups.map(fareGroup => ({
				...fareGroup,
				prices: (fareGroup.prices || []).map(price => ({
					...price,
					price: pricesMap.get(price.flight.id)?.priceToPay ?? null
				}))
			}))
		}));
}
